module.exports = __webpack_public_path__ + "img/lr-cb66-000.fc8bb2c4.gif";